export default "__VITE_ASSET__hTtAV2K7__"